import styled from '@emotion/styled';

import { FUTURO as C } from '../../foundations/color';
import { FUTURO_TYPEFACES as F } from '../../foundations/font';
import S from '../../foundations/size';
import { CircleIconProps } from './CircleIcon.types';

const SIZE_MAP = {
  sm: S.XL,
  md: S.XXL,
  lg: S.XXXL,
};

const FONT_SIZE_MAP = {
  sm: F.H6,
  md: F.H5,
  lg: F.H5,
};

const ICON_COLOR_STATE = {
  default: {
    backgroundColor: C.DARK.SPACE,
    textColor: C.LIGHT.STEEL,
    color: C.LIGHT.STEEL,
  },
  active: {
    backgroundColor: C.LIGHT.PEACH,
    textColor: C.LIGHT.BURNT_ORANGE,
    color: C.LIGHT.BURNT_ORANGE,
  },
  basic: {
    backgroundColor: C.LIGHT.SWAN,
    textColor: C.LIGHT.STEEL,
    color: C.LIGHT.STEEL,
  },
  primary: {
    backgroundColor: C.LIGHT.PEACH,
    color: C.LIGHT.BURNT_ORANGE,
    textColor: C.LIGHT.BURNT_ORANGE,
  },
};

const CircularText = styled('div')<CircleIconProps>`
  height: ${props => SIZE_MAP[props.size]};
  width: ${props => SIZE_MAP[props.size]};
  min-width: ${props => SIZE_MAP[props.size]};
  display: table-cell;
  ${props => FONT_SIZE_MAP[props.size]};
  text-align: center;
  vertical-align: middle;
  border-radius: 50%;
  background: ${props => ICON_COLOR_STATE[props.state].backgroundColor};
  color: ${props => ICON_COLOR_STATE[props.state].textColor};
`;

// if image is squared shape
const CircularSquare = styled('img')<CircleIconProps>`
  height: ${props => SIZE_MAP[props.size]};
  width: ${props => SIZE_MAP[props.size]};
  min-width: ${props => SIZE_MAP[props.size]};
  border-radius: 50%;
`;

// if icon is used
const CircularIcon = styled.div<CircleIconProps>(p => ({
  width: S.XXL,
  height: S.XXL,
  minWidth: S.XXL,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  backgroundColor: ICON_COLOR_STATE[p.state].backgroundColor,
  color: ICON_COLOR_STATE[p.state].color,
}));

export { CircularText, CircularSquare, CircularIcon };
